// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { cancelAccountingConnection } from "./schema/accounting/cancel-accounting-connection";
import { getAccountMappings } from "./schema/accounting/get-account-mappings";
import { getAccountingConnectionSettings } from "./schema/accounting/get-accounting-connection-settings";
import { getAccountingConnections } from "./schema/accounting/get-accounting-connections";
import { getAccountingOAuthUrl } from "./schema/accounting/get-accounting-oauth-url";
import { getChartOfAccounts } from "./schema/accounting/get-chart-of-accounts";
import { getLocationMappings } from "./schema/accounting/get-location-mappings";
import { getQbLocations } from "./schema/accounting/get-qb-locations";
import { saveAccountMappings } from "./schema/accounting/save-account-mappings";
import { saveAccountingConnectionSettings } from "./schema/accounting/save-accounting-connection-settings";
import { saveLocationMappings } from "./schema/accounting/save-location-mappings";

export const groupK: {
  getAccountingOAuthUrl: typeof getAccountingOAuthUrl;
  getAccountingConnections: typeof getAccountingConnections;
  cancelAccountingConnection: typeof cancelAccountingConnection;
  getChartOfAccounts: typeof getChartOfAccounts;
  getQbLocations: typeof getQbLocations;
  getAccountMappings: typeof getAccountMappings;
  saveAccountMappings: typeof saveAccountMappings;
  getLocationMappings: typeof getLocationMappings;
  saveLocationMappings: typeof saveLocationMappings;
  getAccountingConnectionSettings: typeof getAccountingConnectionSettings;
  saveAccountingConnectionSettings: typeof saveAccountingConnectionSettings;
} = {
  getAccountingOAuthUrl,
  getAccountingConnections,
  cancelAccountingConnection,
  getChartOfAccounts,
  getQbLocations,
  getAccountMappings,
  saveAccountMappings,
  getLocationMappings,
  saveLocationMappings,
  getAccountingConnectionSettings,
  saveAccountingConnectionSettings,
};
